import React from 'react';

import Style from './modal-footer.module.css';

export function ModalFooter({ className, children }) {
    return <div className={`${Style['modal-footer']} ${className}`}>{children}</div>;
}
